module.exports = __webpack_public_path__ + "static/media/2.8a63e0b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/healthcare-update-for-pharmacists/2.jpg
// module id = 664
// module chunks = 0